import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Github, Instagram } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 border-t border-slate-800 pt-16 pb-8">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center space-x-3 group">
              <img 
                src="/assets/arnata-logo.png" 
                alt="Arnata Logo" 
                className="h-10 w-auto object-contain transition-transform group-hover:scale-105"
              />
              <span className="text-2xl font-bold text-white group-hover:text-cyan-400 transition-colors" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                Arnata
              </span>
            </Link>
            <p className="text-slate-400 text-sm">
              Engineering solutions untuk web development, IoT, dan DevOps. Membantu mahasiswa dan UMKM mewujudkan project teknologi.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-slate-400 hover:text-cyan-400 text-sm transition-colors">Beranda</Link></li>
              <li><Link to="/services" className="text-slate-400 hover:text-cyan-400 text-sm transition-colors">Layanan</Link></li>
              <li><Link to="/portfolio" className="text-slate-400 hover:text-cyan-400 text-sm transition-colors">Portfolio</Link></li>
              <li><Link to="/about" className="text-slate-400 hover:text-cyan-400 text-sm transition-colors">Tentang</Link></li>
              <li><Link to="/blog" className="text-slate-400 hover:text-cyan-400 text-sm transition-colors">Blog</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Layanan</h4>
            <ul className="space-y-2">
              <li><span className="text-slate-400 text-sm">Web Development</span></li>
              <li><span className="text-slate-400 text-sm">IoT Development</span></li>
              <li><span className="text-slate-400 text-sm">DevOps & Cloud</span></li>
              <li><span className="text-slate-400 text-sm">Engineering Support</span></li>
              <li><span className="text-slate-400 text-sm">Digital Products</span></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Kontak</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-slate-400 text-sm">
                <Mail size={16} className="mt-1 flex-shrink-0" />
                <a href="mailto:arnataproject@gmail.com" className="hover:text-cyan-400 transition-colors">
                  arnataproject@gmail.com
                </a>
              </li>
              <li className="flex items-start space-x-2 text-slate-400 text-sm">
                <Phone size={16} className="mt-1 flex-shrink-0" />
                <a href="https://wa.me/6285183347683" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors">
                  +62 851-8334-7683
                </a>
              </li>
              <li className="flex items-start space-x-2 text-slate-400 text-sm">
                <MapPin size={16} className="mt-1 flex-shrink-0" />
                <span>Way Halim, Bandar Lampung, Lampung, Indonesia</span>
              </li>
            </ul>

            {/* Social Links */}
            <div className="flex space-x-4 mt-6">
              <a href="#" className="text-slate-400 hover:text-cyan-400 transition-colors" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
              <a href="#" className="text-slate-400 hover:text-cyan-400 transition-colors" aria-label="GitHub">
                <Github size={20} />
              </a>
              <a href="https://instagram.com/arnata.project" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-cyan-400 transition-colors" aria-label="Instagram">
                <Instagram size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8 text-center">
          <p className="text-slate-400 text-sm">
            © {currentYear} Arnata. All rights reserved. Built with passion for engineering excellence.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;